var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BlockDivider",style:(_vm.cssVars)},[_c('div',{staticClass:"BlockDivider-Line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }